import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-member-status-badge',
    templateUrl: './member-status-badge.component.html',
    styleUrls: ['./member-status-badge.component.scss'],
    standalone: false
})
export class MemberStatusBadgeComponent {
    @Input() memberStatusLabel: string | null;

    public get cssClassName(): string {
        switch (this.memberStatusLabel) {
            case 'Member':
                return 'badge badge-member-status-member';
            case 'Non-member':
                return 'badge badge-member-status-non-member';
            case 'Terminated':
                return 'badge badge-member-status-terminated';
            case 'Leave of absence':
                return 'badge badge-member-status-loa';
            default:
                return 'badge badge-member-status-non-member';
        }
    }
}
